import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { FulfillmentGroupUpdate } from "@redotech/redo-merchant-fulfillment-rpc/schema/update-fulfillment-groups";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { NoteCell } from "../cells/note-cell";

const catalogEntry = fgColumnEntries["note-from-buyer"];

export const NoteFromBuyerColumn = (
  handleUpdates: (updates: FulfillmentGroupUpdate[]) => void,
): Column2<FulfillmentGroupData> => ({
  key: catalogEntry.key,
  title: catalogEntry.title,
  renderNormalCell: ({ row }) => (
    <NoteCell handleUpdates={handleUpdates} kind="noteFromBuyer" row={row} />
  ),
  width: catalogEntry.defaultWidth,
  alignment: ColumnAlignment.LEFT,
});
